import MessageBox from './MessageBox';
import React from 'react';
import { SUPPORT_MESSAGE } from '../../shared/constants';

const RequestPasswordResetFail = () => {
  return (
    <MessageBox
      header="Whoops!"
      message="Your password reset request has failed."
      secondaryMessage={SUPPORT_MESSAGE}
    />
  );
};

export default RequestPasswordResetFail;
